import MotoInsureRules from './MotoInsureRules';
export default MotoInsureRules;
